import {
  Button,
  Dialog,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTitle,
  FeaturedIcon,
  Icons,
} from '@commenda/kakashi';

interface DeleteGroupModalProps {
  isShown: boolean;
  groupName: string;
  onClose: () => void;
  onDelete: () => void;
}

const DeleteGroupModal = ({
  isShown,
  groupName,
  onClose,
  onDelete,
}: DeleteGroupModalProps) => {
  return (
    <Dialog open={isShown} onOpenChange={(open) => !open && onClose()}>
      <DialogContent>
        <DialogHeader className="border-b-0 flex flex-col gap-lg items-start">
          <FeaturedIcon
            icon={<Icons.AlertTriangle />}
            variant="warning"
            size="lg"
          />
          <div className="space-y-xs">
            <DialogTitle>Delete group?</DialogTitle>
            <p className="txt-medium-regular text-text-secondary">
              You are deleting the group{' '}
              <span className="font-bold">{groupName}</span>. Once done, this
              change cannot be reversed and all information entered will be
              lost.
            </p>
          </div>
        </DialogHeader>
        <DialogFooter className="border-t-0 pt-0">
          <Button variant="secondary" onClick={onClose}>
            Cancel
          </Button>
          <Button variant="destructive-primary" onClick={onDelete}>
            Delete
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export { DeleteGroupModal };
